import { render, staticRenderFns } from "./conversation-add-box.vue?vue&type=template&id=ecc56862&scoped=true"
import script from "./conversation-add-box.vue?vue&type=script&lang=js"
export * from "./conversation-add-box.vue?vue&type=script&lang=js"
import style0 from "./conversation-add-box.vue?vue&type=style&index=0&id=ecc56862&prod&lang=less"
import style1 from "./conversation-add-box.vue?vue&type=style&index=1&id=ecc56862&prod&lang=less&scoped=true"
import style2 from "./conversation-add-box.vue?vue&type=style&index=2&id=ecc56862&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc56862",
  null
  
)

export default component.exports